var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaceFilled = function SvgPlaceFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M12 2.277a7.596 7.596 0 0 0-7.596 7.596v.172c0 1.006.315 2.085.772 3.135.461 1.057 1.088 2.133 1.76 3.144 1.345 2.022 2.908 3.845 3.802 4.836.676.751 1.848.751 2.524 0 .894-.991 2.457-2.814 3.802-4.836.672-1.011 1.299-2.087 1.76-3.144.457-1.05.772-2.13.772-3.135v-.172c0-4.196-3.4-7.596-7.596-7.596Zm0 4.918a2.723 2.723 0 0 0-2.723 2.723v.037a2.723 2.723 0 1 0 5.446 0v-.037A2.723 2.723 0 0 0 12 7.195Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceFilled);
export default ForwardRef;